import { render, staticRenderFns } from "./Marci_masini_list.vue?vue&type=template&id=10ef9b38&scoped=true&"
import script from "./Marci_masini_list.vue?vue&type=script&lang=js&"
export * from "./Marci_masini_list.vue?vue&type=script&lang=js&"
import style0 from "./Marci_masini_list.vue?vue&type=style&index=0&id=10ef9b38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef9b38",
  null
  
)

export default component.exports